export function getYoutubeId(url = "") {
  const match = String(url).match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return match ? match[1] : null;
}

export function youtubeThumb(id) {
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
}

export function youtubeEmbed(id) {
  return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
}

export function isDirectVideo(url = "") {
  return /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url) || url.includes("/storage/v1/object/public/");
}
